module.exports = __webpack_public_path__ + "media/images/design/images/h2_event-5ab0d1d9dae77c8260dc382cdfc06124.png";